import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'sites-i-am-okay';
  constructor(private translate: TranslateService) {}

  ngOnInit() {
    const supportedLanguages = ['de', 'en', 'nl'];
    this.translate.addLangs(supportedLanguages);
    this.translate.setDefaultLang('nl');

    const localLanguage = localStorage.getItem('language');
    if (localLanguage !== null) {
      this.translate.use(
        this.translate.langs.includes(localLanguage.toLowerCase())
          ? localLanguage.toLowerCase()
          : 'nl',
      );
    } else {
      const browserLanguage = navigator.language.substring(0, 2).toLowerCase();
      this.translate.use(this.translate.langs.includes(browserLanguage) ? browserLanguage : 'nl');
    }
  }
}
